import React from "react";
import { useTranslation } from "react-i18next";
import { indexStore } from "../../../store/indexStore";
import Iterator from "src/Components/utils/Iterator";
import { Button } from "src/Components/ui/button";
import { Plus, FolderTree } from "lucide-react";
import AddCategoryModel from "./AddCategoryModel";
import {
  CategoryCard,
  CategoryCardLoading,
} from "src/Components/Cards/CategoryCard";
import Visibility from "src/Components/utils/Visibility";
import { userTypes } from "src/enums/usersTpes";

function Categories(props) {
  const { categoriesLoading, categories } = indexStore();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full gap-6">
      {/* Header Section */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-3 rounded-lg bg-gradient-to-br from-primary/10 to-transparent border">
            <FolderTree className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-foreground">{t("dashbord.categories")}</h2>
            <p className="text-sm text-muted-foreground">
              {t("gloabl.manage_categories_desc") || "Manage and organize your menu categories"}
            </p>
          </div>
        </div>
        <Visibility
          visible={
            localStorage.getItem("role") === userTypes.ADMIN ||
            localStorage.getItem("role") === userTypes.DATAMANAGER
          }
        >
          <AddCategoryModel
            trigger={
              <Button className="gap-2">
                <Plus className="w-4 h-4" />
                <span className="hidden md:block">
                  {t("gloabl.add")} {t("gloabl.category")}
                </span>
                <span className="md:hidden">{t("gloabl.add")}</span>
              </Button>
            }
          />
        </Visibility>
      </div>

      {/* Categories Grid */}
      <div className="flex-1">
        <Visibility visible={categoriesLoading}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            <Iterator
              data={[1, 2, 3, 4]}
              render={(row) => <CategoryCardLoading key={row} />}
            />
          </div>
        </Visibility>
        <Visibility visible={!categoriesLoading}>
          {categories.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              <Iterator
                data={categories}
                render={(row) => <CategoryCard key={row.id} {...row} />}
              />
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-12 text-center text-muted-foreground">
              <FolderTree className="w-16 h-16 mb-4 text-gray-300" />
              <p className="text-xl font-semibold mb-2">{t("gloabl.no_categories_found") || "No categories found"}</p>
              <p className="mb-4">{t("gloabl.categories_will_appear") || "Categories will appear here once you add them"}</p>
              <Visibility
                visible={
                  localStorage.getItem("role") === userTypes.ADMIN ||
                  localStorage.getItem("role") === userTypes.DATAMANAGER
                }
              >
                <AddCategoryModel
                  trigger={
                    <Button variant="outline" className="gap-2">
                      <Plus className="w-4 h-4" />
                      {t("gloabl.add")} {t("gloabl.category")}
                    </Button>
                  }
                />
              </Visibility>
            </div>
          )}
        </Visibility>
      </div>
    </div>
  );
}

export default Categories;
